import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Box, useMediaQuery } from "@mui/material";
import { styled } from "@mui/material/styles";
import GlobalStyles from "./styles/GlobalStyles";
import Background from "./components/layout/Background";
import Navbar from "./components/layout/navbar/Navbar";
import Home from "./pages/Home/Home";
import Contact from "./pages/Contact";
import Administration from "./pages/Admin/administration";
import AdminLayout from "./pages/Admin/AdminLayout";
import Login from "./pages/Login";
import Intro from "./pages/Intro";
import Worship from "./pages/Worship";
import Vision from "./pages/Vision";
import Serve from "./pages/Serve";
import ProtectedRoute from "./components/ProtectedRoute";
import WorshipManagement from "./pages/Admin/WorshipManagement";
import VisionSpaceManagement from "./pages/Admin/VisionSpaceManagement";
import MinistryWorkerManagement from "./pages/Admin/MinistryWorkerManagement";
import DailyEventManagement from "./pages/Admin/DailyEventManagement";
import IntroManagement from "./pages/Admin/IntroManagement";
import "antd/dist/reset.css";

// Mobile Components
import MobileLayout from "./mobile/components/MobileLayout";
import MobileHome from "./mobile/pages/MobileHome";
import MobileIntro from "./mobile/pages/MobileIntro";
import MobileWorship from "./mobile/pages/MobileWorship";
import MobileVision from "./mobile/pages/MobileVision";
import MobileVisionDetail from "./mobile/pages/MobileVisionDetail";
import MobileServe from "./mobile/pages/MobileServe";
import MobileServeDetail from "./mobile/pages/MobileServeDetail";
import MobileContact from "./mobile/pages/MobileContact";
import MobileEventDetail from "./mobile/pages/MobileEventDetail";

const AppContainer = styled(Box)`
  min-height: 100vh;
`;

function App() {
  const isMobile = useMediaQuery("(max-width:900px)");

  return (
    <Router>
      <AppContainer>
        <GlobalStyles />
        {!isMobile && <Background />}
        {!isMobile && <Navbar />}
        <Routes>
          {isMobile ? (
            <Route element={<MobileLayout />}>
              <Route path="/" element={<MobileHome />} />
              <Route path="/event/:id" element={<MobileEventDetail />} />
              <Route path="/intro" element={<MobileIntro />} />
              <Route path="/worship" element={<MobileWorship />} />
              <Route path="/vision" element={<MobileVision />} />
              <Route path="/vision/:id" element={<MobileVisionDetail />} />
              <Route path="/serve" element={<MobileServe />} />
              <Route path="/serve/:id" element={<MobileServeDetail />} />
              <Route path="/contact" element={<MobileContact />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          ) : (
            <>
              <Route path="/" element={<Home />} />
              <Route path="/intro" element={<Intro />} />
              <Route path="/worship" element={<Worship />} />
              <Route path="/vision" element={<Vision />} />
              <Route path="/serve" element={<Serve />} />
              <Route path="/contact" element={<Contact />} />
              <Route
                path="/administration"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={<Navigate to="/administration/home" replace />} // 默认导航到首页事件管理
                />
                <Route path="home" element={<Administration />} />
                <Route path="worship" element={<WorshipManagement />} />
                <Route
                  path="vision-space"
                  element={<VisionSpaceManagement />}
                />
                <Route
                  path="ministry-worker"
                  element={<MinistryWorkerManagement />}
                />
                <Route path="daily-event" element={<DailyEventManagement />} />
                <Route path="intro" element={<IntroManagement />} />
              </Route>
              <Route path="/login" element={<Login />} />
            </>
          )}
        </Routes>
      </AppContainer>
    </Router>
  );
}

export default App;
